import { type Enum } from '@webapp/infrastructure/types/Enum'

// Import-error `detail.code` values known from the Angular modal.
// '0003'/'0009' show the "Duplicate entries detected" Proceed/associate
// prompt; '0011'/'0012' are referenced but unmapped (business meaning
// unconfirmed — feature-doc Gaps).
export const QuickBooksImportErrorCodes = {
  DUPLICATE_ENTRIES_0003: '0003', // duplicate entries → associate
  DUPLICATE_ENTRIES_0009: '0009', // duplicate entries → associate
  CODE_0011: '0011',
  CODE_0012: '0012',
} as const

export type QuickBooksImportErrorCode = Enum<typeof QuickBooksImportErrorCodes>
